import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';
import { ArrowSquareOutIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { useCan } from '@/hooks/useCan';

/**
 * The Supply Network page's name as a link, or as plain text for a viewer who
 * can't open the page: warehouse readers don't all have Supply Network Read.
 */
export function SupplyNetworkLink({
  children,
  icon = false,
}: {
  children: ReactNode;
  /** Marks the link as leading to another page. */
  icon?: boolean;
}) {
  const [canRead] = useCan(Action.Read, Subject.SupplyNetwork);
  if (!canRead) {
    return <span className="font-medium text-gray-900">{children}</span>;
  }
  return (
    <Link
      to="/inventory-management/supply-network"
      className={`font-medium text-gray-900 underline-offset-2 hover:underline${icon ? ' inline-flex items-center gap-0.5' : ''}`}
    >
      {children}
      {icon && <ArrowSquareOutIcon className="h-3.5 w-3.5" />}
    </Link>
  );
}
